export const baseUrl = process.env.VUE_APP_MODE === 'prod' ? '/admin/' : '/'
export const resourceServer = 'https://qnoss.hlqk.net'
export const localResourceServer = '//wechattest.dpmall.com/resources'


// WEBPACK FOOTER //
// ./src/config/common.js